module.exports = __webpack_public_path__ + "img/blog_cover.a9abb98f.png";